// 📦 Phase 6 — Versions envoyées d'une facture client (PDF exact archivé), téléchargement via lien signé.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Download } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('auth_token')}` });

export function VersionsEnvoyees({ factureId, rafraichir }) {
  const [versions, setVersions] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/api/crm/factures/${factureId}/archives`, { headers: headers() }).then((r) => setVersions(r.data.versions || [])).catch(() => setVersions([]));
  }, [factureId, rafraichir]);
  if (!versions || versions.length === 0) return null;
  return (
    <div className="mt-3 border-t pt-2" data-testid={`versions-envoyees-${factureId}`}>
      <p className="text-xs font-semibold text-slate-600 mb-1">Versions envoyées</p>
      <ul className="space-y-1">
        {versions.map((v) => (
          <li key={v.version} className="flex items-center justify-between text-xs bg-slate-50 rounded px-2 py-1" data-testid={`version-envoyee-${factureId}-${v.version}`}>
            <span>v{v.version} · {new Date(v.date_envoi).toLocaleString('fr-CA')} · {v.canal === 'courriel' ? `courriel → ${v.envoye_a || '—'}` : 'lien public'}{v.envois?.length > 1 ? ` · ${v.envois.length} envois` : ''}</span>
            <a href={`${API_URL}${v.url_telechargement}`} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline flex items-center gap-1" data-testid={`version-telecharger-${factureId}-${v.version}`}><Download className="w-3 h-3" /> Télécharger</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
